export const columna = [

	

   {
		"nombre": "Noticias.",
		"imagen": 'noticias/requisitos.jpg',
	   "funcion": 'Publicación de Secretaría de Contraloría Hidalgo.',
		"url" : 'https://www.facebook.com/SecretariaContraloriaHgo/posts/pfbid0ZyeqDMrD79N9odE2pdUeJHua1hBAFpeuqu9iEzZZ4bybQWfUkju9nAoHC5oUetBkl?rdid=TdHF8xosZNPp27hw#',
	},




	
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/sesenta.jpg',
	    "funcion": '60 segundos.',
		"url" : 'https://www.facebook.com/reel/1799116924607749',
	},



		{
		"nombre": "Noticias.",
		"imagen": 'noticias/podpueblo.jpg',
	    "funcion": 'El Podcast del Pueblo.',
		"url" : 'https://www.facebook.com/reel/2566759687097641',
	},


	{
		"nombre": "Noticias.",
		"imagen": 'noticias/buzón.jpg',
		"funcion": "Buzón Digital",
		"url": "https://buzondigitalcontraloria.hidalgo.gob.mx/"
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]